import { Sparkles } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { cx } from "$src/lib/utils";
import styles from "./mini-chat-button.module.css";

export interface MiniChatButtonProps {
  className?: string;
}

export const MiniChatButton = ({ className }: MiniChatButtonProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = () => {
    // Navigate to ask-ai under the current team slug
    const teamSlug = pathname.split("/")[1];
    navigate(`/${teamSlug}/ask-ai`);
  };

  return (
    <button className={cx(styles.button, className)} onClick={handleClick}>
      <Sparkles size={14} className={styles.icon} />
      <span>Ask AI</span>
    </button>
  );
};
